module.exports = __webpack_public_path__ + "images/forbes-1b99d5.svg";